<template>
    <div class="survey-report">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'surveyDetails' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Survey Report
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="top-navbar-right">
                            <button @click="exportSurveys" class="btn btn-ecdc btn-shadow ml-3">Export Report</button>
                        </div>
                    </div>
                </div>
            </div>

            <hr />

            <div class="row">
                <div id="table-content-col" class="col-lg">

                    <div class="table-responsive" >
                        <table class="table table-striped table-hover result-table">
                            <thead>
                                <tr>
                                    <th>Index</th>
                                    <th v-for="(column) in columns" v-bind:key="column.id">{{column}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(answer,index) in answers" v-bind:key="answer.id">
                                    <td>{{index+1}}</td>
                                    <td v-for="(column) in columns" v-bind:key="column.id">
                                        <span v-for="result in answer" v-bind:key="result.id">
                                            <span v-if="result.title == column && result.type == 'checkbox'">{{result.value.join(", ")}}</span>
                                            <span v-else-if="result.title == column && result.type == 'image'">
                                                <div @click="bindImageUrl(url+result.profile_image_preview,result.title)" class="custom-modal-select">View Image</div>
                                            </span>
                                            <span v-else-if="result.title == column && (result.value != '' || (result.value.length>0))">{{result.value}}</span>
                                            <span v-else-if="result.title == column && (result.value == '' || result.value == 'null' || (result.value.length==0))">-</span>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="image-modal" hide-header hide-footer centered size="xl">
            <img src="../assets/img/icon-close.png" alt="icon-close" class="img-fluid modal-close" @click="$bvModal.hide('image-modal')" /> 

            <div class="selection-modal">
                <h4 class="title text-left mb-5">{{imageTitle}}</h4>

                <div class="form-group">
                    <div class="d-flex justify-content-center">
                        <img :src="imageUrl" width="auto" height="300" alt="">
                    </div>
                </div>

                <div>
                    <button type="button" class="btn btn-ecdc" @click="$bvModal.hide('image-modal')">Close</button>
                </div>
            </div>            
        </b-modal>

        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { surveyReport, getPrograms, getSurveysReport } from '../api'
import Loader from './Loader.vue'

export default {
    components: {
        appLoader: Loader
    },
    data() {
        return {
            columns:[],
            answers:[],
            imageUrl:"",
            imageTitle:"",
            url:process.env.VUE_APP_IMAGE_BASE_URL,
            isLoading: false
        }
    },
    async mounted() {
        await this.getPrograms();
        await this.surveyReport();
    },
    methods: {
        async surveyReport(pageNum) {

            try {

                const result = await surveyReport({id:this.$route.params.id}, pageNum, this.pageLimit);
                // console.log (result.data.data.answers);
                this.columns = result.data.data.columns;
                this.answers = result.data.data.answers;
                
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getPrograms() {

            try {
                const result = await getPrograms(this.defaultProject)
                this.programsData = result.data.data;
            }
            catch(err) {

                alert(err.response.data.message);
            }
        },
        bindImageUrl(url, title) {
            this.$bvModal.show('image-modal')
            this.imageUrl = url;
            this.imageTitle = title;
        },
        async exportSurveys() {
            this.isLoading = true;
            try {
                const result = await getSurveysReport({id:this.$route.params.id});

                let fileURL = window.URL.createObjectURL(new Blob([result.data]));
                let fileLink = document.createElement("a");

                fileLink.href = fileURL;

                let moment = require("moment");
                let date = moment().format("DDMMYYYY");

                fileLink.setAttribute("download", `SURVEY_${date}.xlsx`);

                document.body.appendChild(fileLink);
                fileLink.click();

                this.isLoading = false;
            } catch (err) {
                alert(err.response.data.message);
            }
            this.isLoading = false;
        }
    }
}
</script>

